import Immutable from 'immutable'

import { RecipeCoreId } from '@library/menu-service'

import basketConfig from 'config/basket'
import Cookies from 'utils/GoustoCookies'

import { unset } from './cookieHelper2'

export const basketSum = (items: Immutable.Map<RecipeCoreId, number>): number => {
  const quantities = Object.values(items.toJS()) as number[]

  return quantities.reduce((sum, qty) => sum + qty, 0)
}

export const naiveLimitReached = (
  basket: Immutable.Map<string, unknown>,
  maxRecipesNum = basketConfig.maxRecipesNum,
): boolean =>
  basketSum(basket.get('recipes') as Immutable.Map<RecipeCoreId, number>) >= maxRecipesNum

export const limitReached = (
  basketUsage: number,
  maxRecipesNum = basketConfig.maxRecipesNum,
): boolean => basketUsage >= maxRecipesNum

export function basketResetPersistent(cookie: typeof Cookies): void {
  unset(cookie, 'goustoStateStore_basket_slotId')
  unset(cookie, 'goustoStateStore_basket_recipes')
  unset(cookie, 'goustoStateStore_basket_previewOrderId')
  unset(cookie, 'goustoStateStore_basket_postcode')
  unset(cookie, 'goustoStateStore_basket_numPortions')
  unset(cookie, 'goustoStateStore_basket_numRecipes')
  unset(cookie, 'goustoStateStore_basket_date')
  unset(cookie, 'goustoStateStore_menu_selectedRecipeVariants')
}
